import { Col, Row } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { type BankIntegrationProvider } from '../../../../../../api/types';
import InputField from '../../../../../../components/fields/InputField';
import BankIntegrationFields from '../../../../BankDetailsPage/BankForm/BankIntegrationFields';

const colSpan = { lg: 24, md: 24, sm: 24, xs: 24 };

export type BankIntegrationFieldsProps = {
    provider: BankIntegrationProvider;
    isUpdate?: boolean;
};

const BankFields = ({ isUpdate = false, provider }: BankIntegrationFieldsProps) => {
    const { t } = useTranslation(['sdmModuleDetails']);

    return (
        <Row gutter={14}>
            <Col {...colSpan}>
                <InputField
                    {...t('sdmModuleDetails:fields.displayName', { returnObjects: true })}
                    name="displayName"
                    required
                />
            </Col>

            <Col {...colSpan}>
                <InputField
                    {...t('sdmModuleDetails:fields.identifier', { returnObjects: true })}
                    name="identifier"
                    required
                />
            </Col>

            <Col {...colSpan}>
                <InputField
                    {...t('sdmModuleDetails:fields.dealerCode', { returnObjects: true })}
                    name="dealerCode"
                    required
                />
            </Col>

            <BankIntegrationFields isUpdate={isUpdate} provider={provider} compact nested />
        </Row>
    );
};

export default BankFields;
